import React, { useEffect, useState } from 'react';
import { LuCheck, LuCopy, LuExternalLink, LuLink2Off, LuShare2 } from 'react-icons/lu';
import { Modal } from '../ui/Modal';
import Button from '../ui/Button';
import Alert from '../ui/Alert';
import { INPUT_CLASS } from '../ui/Field';

/** Public link of a published report: copy, open, or revoke it. */
const ShareReportModal = ({ isOpen, onClose, publicUrl, onDisable, isDisabling = false, error = null }) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return undefined;
    const t = setTimeout(() => setCopied(false), 3000);
    return () => clearTimeout(t);
  }, [copied]);

  const copy = () => {
    navigator.clipboard?.writeText(publicUrl).then(
      () => setCopied(true),
      (err) => console.error('Erreur lors de la copie du lien:', err),
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      icon={LuShare2}
      title="Partager le rapport"
      subtitle="Toute personne disposant du lien peut consulter ce rapport, sans compte."
      size="md"
      footer={<Button onClick={onClose}>Fermer</Button>}
    >
      <div className="space-y-5">
        {error && <Alert tone="danger">{error}</Alert>}

        <div>
          <label htmlFor="public-link" className="mb-1.5 block text-xs font-semibold text-gray-700 dark:text-gray-300">Lien de partage public</label>
          <div className="flex flex-col gap-2 sm:flex-row">
            <input
              id="public-link"
              type="text"
              value={publicUrl}
              readOnly
              onFocus={(e) => e.target.select()}
              className={`${INPUT_CLASS} font-mono !text-xs`}
            />
            <div className="flex gap-2">
              <Button variant="primary" icon={copied ? LuCheck : LuCopy} onClick={copy} className="flex-1 sm:flex-none">
                {copied ? 'Copié' : 'Copier'}
              </Button>
              <Button as="a" href={publicUrl} target="_blank" rel="noopener noreferrer" icon={LuExternalLink} className="flex-1 sm:flex-none">
                Ouvrir
              </Button>
            </div>
          </div>
          <p className="mt-2 text-xs text-gray-500 dark:text-gray-400" aria-live="polite">
            {copied ? 'Lien copié dans le presse-papier.' : 'Le rapport partagé présente les analyses et la galerie, sans les photos masquées.'}
          </p>
        </div>

        <div className="rounded-xl border border-red-200 bg-red-50/60 p-4 dark:border-red-900/60 dark:bg-red-950/30">
          <p className="text-sm font-semibold text-red-800 dark:text-red-200">Désactiver le lien</p>
          <p className="mt-0.5 text-xs text-red-700/90 dark:text-red-300/90">
            Le lien actuel cessera de fonctionner pour tous ceux qui l'ont reçu. Vous pourrez en générer un nouveau plus tard.
          </p>
          <Button variant="danger" size="sm" icon={LuLink2Off} onClick={onDisable} loading={isDisabling} className="mt-3">
            Désactiver ce lien public
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ShareReportModal;
